import { createFileRoute } from "@tanstack/react-router";
import { SectionHeading } from "../components/SectionHeading";
import { ContactForm } from "../components/ContactForm";
import { ContactDetails } from "../components/ContactDetails";
import { SITE_URL, ogImageDefault, ogImageMeta } from "../lib/seo";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact — Fedor Timmerwerken" },
      {
        name: "description",
        content:
          "Vertel ons over je volgende project. Vul het formulier in of bel Fedor Timmerwerken voor een gratis adviesgesprek aan huis in Dordrecht.",
      },
      { property: "og:title", content: "Contact — Fedor Timmerwerken" },
      {
        property: "og:description",
        content: "Vraag een vrijblijvende offerte aan of plan een gratis adviesgesprek aan huis.",
      },
      { property: "og:url", content: `${SITE_URL}/contact` },
      ...ogImageMeta(ogImageDefault, "Fedor Timmerwerken — vraag een vrijblijvende offerte aan"),
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/contact` }],
  }),
  component: ContactPage,
});

function ContactPage() {
  return (
    <div className="py-14 sm:py-20 lg:py-28">
      <div className="container-tight">
        <SectionHeading
          as="h1"
            eyebrow="Contact"
          title="Contact met Fedor Timmerwerken"
          description="Vul het formulier in of bel ons voor een gratis adviesgesprek aan huis."
          align="center"
          className="mx-auto"
        />

        <div className="mt-10 sm:mt-14 grid gap-10 lg:grid-cols-3">
          <div className="lg:col-span-1">
            <ContactDetails />
          </div>

          <div className="lg:col-span-2">
            <div className="rounded-2xl border border-border/60 bg-card p-6 lg:p-8">
              <h2 className="font-heading text-xl font-semibold text-foreground">
                Stuur een bericht
              </h2>
              <p className="mt-2 text-sm text-muted-foreground">
                We reageren zo snel mogelijk op je aanvraag.
              </p>
              <div className="mt-6">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
